<template>
  <div class="settings-actions">
    <div class="settings-actions__header">
      <div class="row m-0 items-center justify-end">
        <div class="col-1/x">
          <div class="settings-actions__breadcrumbs">
            <ul class="podcast-breadcrumbs flex">
              <li class="breadcrumb-item">{{ rootName }}</li>
              <li class="breadcrumb-item">
                <span class="separator">
                  <ChevronRight />
                </span>
                <strong>{{ elementName }}</strong>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-auto">
          <div class="settings-actions__button">
            <button
              class="btn-primary"
              :disabled="disabled"
              @click="$emit('update')"
            >
              Salva
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/** Icons */
import ChevronRight from '@/assets/icons/icon-chevron_right.svg'

export default {
  components: {
    ChevronRight,
  },

  props: {
    rootName: {
      type: String,
      required: true,
    },
    elementName: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },

    title: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss">
.podcast-breadcrumbs {
  @apply flex;
}

.breadcrumb-item {
  @apply text-xl font-sans pr-3;
}

.separator {
  @apply inline-block w-4 pr-3 align-middle;
}
</style>
